import Cookies from 'js-cookie';
import { MetadataService } from 'oidc-client';

class SSOLogoutBySession extends MetadataService {
  async getEndSessionEndpoint() {
    // Log inicial ao chamar a função

    const sid = Cookies.get('sid');

    let endSessionEndpoint = new URL(process.env.REACT_APP_AUTH_ENDPOINT);

    // Checa e loga a condição de REACT_APP_LOGOUT_URI
    if (process.env.REACT_APP_LOGOUT_URI) {
      endSessionEndpoint = new URL(await this.getTokenEndpoint());
    }

    // Modifica o pathname e loga o novo valor
    endSessionEndpoint.pathname = 'account/logout';

    // Define o logoutUri e loga seu valor
    const logoutUri =
      `${process.env.REACT_APP_LOGOUT_URI}${sid ? `&session_id=${sid}` : ''}` ||
      `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ''
      }`;

    // Modifica os parâmetros de busca da URL e loga a URL final
    endSessionEndpoint.searchParams.set('logout_uri', logoutUri);

    // Retorna a URL final e loga o retorno
    const finalHref = endSessionEndpoint.href + `&session_id=${sid}`;

    localStorage.clear();
    sessionStorage.clear();
    Cookies.remove('sid');

    return finalHref;
  }
}

export default SSOLogoutBySession;
